import { useState } from 'react';

import { Campaign } from 'domains/campaigns/types';
import ConfirmationDialog from 'domains/core/components/ConfirmationDialog';
import ErrorSnackbar from 'domains/core/components/Snackbars/ErrorSnackbar';
import InfoSnackbar from 'domains/core/components/Snackbars/InfoSnackbar';
import SuccessSnackbar from 'domains/core/components/Snackbars/SuccessSnackbar';
import useArchiveCampaignItem from 'hooks/useArchiveCampaignItem';

export type Props = {
    activeItem: Campaign;
    handleModalClose: () => void;
    isOpen: boolean;
    refetchTableData: () => void;
    resetActiveItem: () => void;
};

const ArchiveCampaignModal = ({ activeItem, handleModalClose, isOpen, refetchTableData, resetActiveItem }: Props) => {
    const [errorMessage, setErrorMessage] = useState('');
    const [successMessage, setSuccessMessage] = useState('');

    const { getArchiveItemFunction, isLoading, isSuccess } = useArchiveCampaignItem({
        activeItem,
        refetchTableData,
        resetActiveItem,
        setErrorMessage,
        setSuccessMessage,
    });

    const handleArchive = () => {
        const archiveItem = getArchiveItemFunction();
        archiveItem();
        handleModalClose();
    };

    const onCancel = () => {
        handleModalClose();
        resetActiveItem();
    };

    const infoMessage = `Archiving "${activeItem?.name}"`;
    const contentText = `You are about to archive "${activeItem?.name}." This will move the curation to the archive list.`;

    return (
        <>
            {errorMessage && <ErrorSnackbar errorMessage={errorMessage} />}
            {isLoading && <InfoSnackbar successMessage={infoMessage} />}
            {isSuccess && <SuccessSnackbar successMessage={successMessage} />}
            <ConfirmationDialog
                dialogProps={{
                    confirmButtonText: 'Archive',
                    contentText,
                    title: 'Archive curation',
                }}
                onCancel={onCancel}
                onConfirm={handleArchive}
                onModalClose={handleModalClose}
                open={isOpen}
            />
        </>
    );
};

export default ArchiveCampaignModal;
